import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Flex } from '@leverege/ui-elements';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import Model from "./CustomTextAttributeModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function CustomTextAttributeEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const formatterEditor = ModelEditorFactory.create(value.formatter, {
    onChange: onModelChange,
    eventData: 'setFormatter'
  });
  if (!formatterEditor) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    variant: "colM",
    children: formatterEditor
  });
}
CustomTextAttributeEditor.canEdit = canEdit;
function canEdit(model) {
  return model.formatter !== null;
}